export class GraphLines {
    public goal: number[] = [];
    public down: number[] = [];
    public expected: number[] = [];
    public clientScenario: number[] = [];
    public up: number[] = [];
}
